import { useState } from "react";
import { Form, Select, Button, Space, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons"; // Importar el icono
import CreateUser from "../../Users/components/createModal";
import { typesUsers } from "../../../utils/constants";
import { userTypes } from "../../../types";
import { useQuery } from "@apollo/client";
import { GET_USERS } from "./requests";

const { Option } = Select;
const { Text } = Typography;

interface UserSelectionFormProps {
  selectedUsers: Record<string, string[]>;
  setSelectedUsers: (users: Record<string, string[]>) => void;
}

const UserSelectionForm = ({ selectedUsers, setSelectedUsers }: UserSelectionFormProps) => {
  const [form] = Form.useForm();
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [creatingType, setCreatingType] = useState<string | null>(null);

  const { data, refetch } = useQuery(GET_USERS, {
    variables: {
      page: 1,
      pageSize: 100,
    },
  });

  const users = data?.users?.results ?? [];

  const addUser = (type: string) => {
    if (!selectedUsers[type].includes("")) {
      setSelectedUsers({
        ...selectedUsers,
        [type]: [...selectedUsers[type], ""],
      });
    }
  };

  const handleSelectChange = (type: string, index: number, value: string | undefined) => {
    const newValue = value === undefined ? "" : value;

    const updatedUsers = [...selectedUsers[type]];
    updatedUsers[index] = newValue;

    setSelectedUsers({
      ...selectedUsers,
      [type]: updatedUsers,
    });
  };

  const handleRemoveSelect = (type: string, index: number) => {
    const updatedUsers = selectedUsers[type].filter((_, i) => i !== index);
    setSelectedUsers({
      ...selectedUsers,
      [type]: updatedUsers,
    });
  };

  const handleOpenCreateUser = (type: string) => {
    setCreatingType(type);
    setShowCreateUserModal(true);
  };

  const handleUserCreated = async (newUser: typeof userTypes.user) => {
    setSelectedUsers({
      ...selectedUsers,
      [creatingType as string]: [
        ...selectedUsers[creatingType as string].filter((id) => id !== ""),
        newUser.id,
      ],
    });
    await refetch();
  };

  const filterAvailableUsersForType = (type: string) => {
    const allSelectedIds = Object.values(selectedUsers)
      .flat()
      .filter((id) => id !== "");

    return users.filter(
      (user) =>
        user.type === type && !allSelectedIds.includes(user.id),
    );
  };

  return (
    <>
      <Form form={form} layout="vertical">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 16,
          }}
        >
          {[typesUsers.manager.value, typesUsers.operation.value, typesUsers.dropoff.value].map(
            (type) => (
              <div key={type} style={{ width: "30%" }}>
                <Text strong>{typesUsers[type].name}: </Text>
                {selectedUsers[type].map((userId, index) => (
                  <Space key={index} style={{ display: "flex",
                    marginBottom: 8 }}>
                    <Select
                      style={{ width: 305 }}
                      onChange={(value) => {
                        if(value.value === "create") {
                          handleOpenCreateUser(type)
                        } else {
                          handleSelectChange(type, index, value.value);
                        }
                      }}
                      value={userId ? { value: userId,
                        label: `${users.find((user) => user.id === userId)?.firstName} ${users.find((user) => user.id === userId)?.lastName}` } : undefined}
                      placeholder={`Seleccionar ${typesUsers[type].name}`}
                      allowClear
                      labelInValue
                    >
                      {filterAvailableUsersForType(type).map((user) => (
                        <Option key={user.id} value={user.id}>
                          {user.firstName} {user.lastName}
                        </Option>
                      ))}
                      <Option value="create">
                        + Crear nuevo {typesUsers[type].name}
                      </Option>
                    </Select>
                    <Button
                      type="dashed"
                      icon={<DeleteOutlined />}
                      style={{
                        marginLeft: 5,
                        borderColor: "red",
                        color: "red",
                      }}
                      onClick={() => handleRemoveSelect(type, index)}
                    />
                  </Space>
                ))}
                <Button
                  type="dashed"
                  onClick={() => addUser(type)}
                  style={{ width: "100%" }}
                >
                  + Agregar {typesUsers[type].name}
                </Button>
              </div>
            ),
          )}
        </div>
      </Form>
      {showCreateUserModal && (
        <CreateUser
          showModal={showCreateUserModal}
          setShowModal={setShowCreateUserModal}
          refetch={() => {}}
          onUserCreated={handleUserCreated}
          isLocationView={true}
        />
      )}
    </>
  );
};

export default UserSelectionForm;
